module.exports = __webpack_public_path__ + "img/paper-plane-right.4285bf37.svg";